import {documentActivities,getDocumentPreview,encrypt,decrypt} from "../services/http-services/HttpServices";
import { SET_DOCUMENT_ACTIVITY_DATA,SET_DOCUMENT_PREVIEW_DATA } from "../config";
import { showLoader,hideLoader,notification } from "./uiAction";

function setDocumentActivities(data) {
	return {
		type: SET_DOCUMENT_ACTIVITY_DATA,
		documentActivity:data
	}
}
function setDocumentPreview(data) {
	return {
		type: SET_DOCUMENT_PREVIEW_DATA,
		documentPreview:data
	}
}

/* Name : Neha 
   Description : Function is used to fetch the dockets and set to dashboard page
 */
export function getDocumentActivities() {
  return function(dispatch) {
	  dispatch(showLoader())
    return documentActivities()
      .then(json => {
	  dispatch(setDocumentActivities(json))
		 dispatch(hideLoader())
	  })
	  
  }
}
export function previewDocument(status,documentId) {
  return function(dispatch) {
	  dispatch(showLoader())
	  var data = JSON.stringify({documentId:documentId,status:status});
    return getDocumentPreview(data)
      .then(response => {
			response = response.response;
		    if(response != 0 || response != '0') {
				response = decrypt(response);
				response = JSON.parse(response);
			}

			dispatch(hideLoader());
			if(response!='0')
			{
				dispatch(setDocumentPreview(response))
			} else {
				dispatch(notification("File Does Not Exist!"));
			}

	  })
	  
  }
}